import { Hold } from '../models/Hold';
export function getHoldListFromCache(): Hold[] {
    const holdListString = localStorage.getItem('holdList');
    if (holdListString === null) {
        throw Error('Holdliste findes ikke i cache. Log af og log på igen');
    }

    return JSON.parse(holdListString);
}

export function setHoldListCache(holdList: Hold[]) {
    localStorage.setItem('holdList', JSON.stringify(holdList));
}

export function clearHoldListCache() {
    localStorage.removeItem('holdList');
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/HoldListCache.ts